/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom'
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Card, CardContent, Divider, Typography, IconButton } from '@material-ui/core';
import { ArrowBack, Edit, Clear } from '@material-ui/icons'

import RecordIcon from './RecordIcon'
import GroupIcon from '../Groups/GroupIcon';
import SingletonIcon from '../Singletons/SingletonIcon'

class Record extends Component {
    state = {

    }

    componentWillUnmount() {
        this.props.unfocus_record(this.props.record)
    }

    componentDidMount() {
        console.log('IRC :: Record Details :',this.props.record)
    }

    isFocussed = () => {
        if (this.props.field_in_focus === null) {
            return false
        } else {
            if (this.props.field_in_focus.field === this.props.field_data.field) {
                return true
            } else {
                return false
            }
        }
    }

    render() {
        console.log('IRC :: Record Details :',this.props.record)
        return (
            <Card>
                <CardContent>
                    <div style={{display: 'flex', flexDirection:'column', height:'100%'}}>
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', marginBottom : '5px'}}>
                            <IconButton style = {{marginRight : '10px'}} size = 'small' color = 'primary' onClick = {() => {
                                this.props.unfocus_record(this.props.record)
                                this.props.unfocus_field()
                                }}>
                                <ArrowBack fontSize = 'inherit'/>
                            </IconButton>
                            {this.props.record.group_id !== -1 && <GroupIcon/>}
                            {this.props.record.group_id !== -1 && <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.record.group_name}</Typography>}
                            {this.props.record.group_id !== -1 && <Typography style = {{marginRight : '5px'}} variant = 'caption' color ='primary'>/</Typography>}
                            {this.props.record.group_id !== -1 ? <RecordIcon/> : <SingletonIcon/>}
                            <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.record.record_id}</Typography>
                        </div>
                        <Divider style = {{marginBottom : '5px'}} />
                        {
                            Object.keys(this.props.record.wv_field_list).map((key)=>{
                                return (
                                    <div style = {{marginBottom : '5px'}}>
                                        <Typography variant = 'subtitle2' color ='textPrimary'>{key}</Typography>
                                        <Typography variant = 'subtitle2' color ='textSecondary'>{this.props.record.wv_field_list[key]}</Typography>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                </CardContent>
            </Card>
        );
    }
}

export default Record